import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    ExternalDespatchLinkColumn,
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    MultilineColumn,
    MultilineDateTimeColumn,
    MultilineNumberColumn,
  } = columns(data);

  return [
    {
      Header: 'Despatch',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('ID', 'despatch.id').withWidth(200)),
        new DateTimeColumn('Closed date', 'despatch.closedDate'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NonZeroNumberColumn('PREDES', 'receptacles.predes'),
        new NonZeroNumberColumn('RESDES', 'receptacles.resdes'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('First scan', 'resdes.firstScan'),
        new DateTimeColumn('Last scan', 'resdes.lastScan'),
      ],
    },
    {
      Header: 'Items',
      columns: [
        new NonZeroNumberColumn('PREDES', 'items.predes'),
        new NonZeroNumberColumn('RESDES', 'items.resdes'),
        new NonZeroPercentageColumn('% responded', 'items.pctResponded'),
      ],
    },
    {
      Header: 'PREDES transport',
      columns: [
        new TextColumn('Carrier', 'predesTransport.carrier'),
        new TextColumn('Conveyance reference', 'predesTransport.conveyanceReference'),
        new DateTimeColumn('Planned departure', 'predesTransport.plannedDeparture'),
        new DateTimeColumn('Planned arrival', 'predesTransport.plannedArrival'),
      ],
    },
    {
      Header: 'RESDES transport',
      columns: [
        new MultilineColumn('Carrier', 'resdesTransport.carrier'),
        new MultilineColumn('Conveyance reference', 'resdesTransport.conveyanceReference'),
        new MultilineDateTimeColumn('Actual arrival', 'resdesTransport.actualArrival'),
        new MultilineNumberColumn('Receptacles', 'resdesTransport.receptacles'),
      ],
    },
  ];
};
